"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Name = exports.LinkClick = void 0;
const Name = exports.Name = 'link-click';
const LinkClick = exports.LinkClick = Name;
//# sourceMappingURL=index.js.map